import { EnterpriseMember } from 'models/Enterprises';

export type ManageEnterprisePeopleTable = Pick<
  EnterpriseMember,
  'seniority' | 'title' | 'businessUnitName' | 'location' | 'email'
> &
  Record<'checkbox' | 'name' | 'invited' | 'mobile' | 'linkedIn', string>;

export const TABLE_COLUMNS: Array<keyof ManageEnterprisePeopleTable> = [
  'checkbox',
  'name',
  'email',
  'seniority',
  'title',
  'businessUnitName',
  'location',
  'invited',
  'mobile',
  'linkedIn',
];

export const HEADING_TRANSLATIONS = {
  checkbox: '',
  name: 'name',
  seniority: 'seniority',
  title: 'title',
  businessUnitName: 'businessUnit',
  location: 'location',
  invited: 'invited',
  email: 'email',
  mobile: 'mobile',
  linkedIn: 'linkedin',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  seniority: 'seniority',
  businessUnitName: 'businessUnitName',
  location: 'location',
  invited: 'invitationStatusSort',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  checkbox: 50,
  name: 250,
  email: 350,
  seniority: 110,
  title: 140,
  businessUnitName: 130,
  location: 130,
  invited: 90,
  mobile: 210,
  linkedIn: 110,
};
